
import React from "react";
import { ApproveScheduleDialog } from "../ApproveScheduleDialog";
import { EventDialog } from "../../EventDialog";
import { useTranslations } from "@/hooks/useTranslations";

interface EventDialogsProps {
  showApproveDialog: boolean;
  showEventDialog: boolean;
  selectedEvent: any | null;
  onCloseApprove: () => void;
  onCloseEvent: () => void;
  onEventUpdated: () => void;
  onEventDeleted: (event: any) => void;
  isDeleting: boolean;
}

export const EventDialogs: React.FC<EventDialogsProps> = ({
  showApproveDialog,
  showEventDialog,
  selectedEvent,
  onCloseApprove,
  onCloseEvent,
  onEventUpdated,
  onEventDeleted,
  isDeleting
}) => {
  const { t } = useTranslations("schedule");
  
  if (!selectedEvent) return null;
  
  // Handle approval confirmation
  const handleApprovalComplete = () => {
    if (selectedEvent) {
      // Update the UI immediately and refresh events from server
      onEventUpdated();
    }
  };
  
  return (
    <>
      {showApproveDialog && (
        <ApproveScheduleDialog 
          isOpen={showApproveDialog} 
          onClose={onCloseApprove} 
          event={selectedEvent} 
          onEventUpdated={handleApprovalComplete} 
        />
      )}
      
      {showEventDialog && (
        <EventDialog
          isOpen={showEventDialog}
          onClose={onCloseEvent}
          selectedEvent={selectedEvent}
          onEventSaved={onEventUpdated}
          onEventDeleted={onEventDeleted}
          isDeleting={isDeleting}
        />
      )}
    </>
  );
};
